import React, { Component, Fragment } from "react";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DateFnsUtils from "@date-io/date-fns";
import {
  DatePicker,
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import SearchIcon from "@material-ui/icons/Search";
import Button from "@material-ui/core/Button";
import EventIcon from "@material-ui/icons/Event";
import InputAdornment from "@material-ui/core/InputAdornment";
import Skeleton from "@material-ui/lab/Skeleton";
import AccessibleIcon from "@mui/icons-material/Accessible";
import Grid from "@material-ui/core/Grid";
import { styled, TextField, Link, Dialog, DialogContent } from "@mui/material/";
import EditIcon from "@mui/icons-material/Edit";
//Import styles
import "./DashboardConsolExclusions.scss";
//Import components
import fetchAPI from "../../../../components/utils/fetchAPI";
import IconButton from "@material-ui/core/IconButton";
import Dropdown from "react-bootstrap/Dropdown";
import DropdownButton from "react-bootstrap/DropdownButton";
import Paginador from "../../Components/Pagination/pagination";
import runtimeEnv from "@mars/heroku-js-runtime-env";
import DetailExclusions from "./DetailExclusions";
import DataTable from "../../Components/DataTable/DataTable";
import DialogHoneyLoad from "../../Components/DialogHoneyLoad/DialogHoneyLoad";
import DownloadIcon from "@mui/icons-material/Download";

const env = runtimeEnv();

export default class DashboardLoader extends Component {
  state = {
    tableColumns: [
      "Id SKU",
      "Descripcion",
      "No de Exclusiones",
      // "No de Incluidos",
      "Estatus",
      "Fecha Inicio",
      "Fecha Termino",
      "Vigencia",
      "Usuario",
      "Útima Actualización",
    ],
    rows: [],
    checked: false,
    handleChangeD: this.handleChangeD.bind(this),
    rowsForModal: [],
    rowsSKU: [],
    rowsSKUForModal: [],
    rowsData: [],
    rowsExclutions: [],
    rowsPromotions: [],
    labelDropdown: "Descargar ",
    dropdownOptions: [""],
    dialogOpen: false,
    dialogSectionFile: true,
    dialogLoadingFile: false,
    currentFile: undefined,
    fileProgress: 0,
    responseFileProgress: "",
    responseCompletedSKU: false,
    responseCompletedClient: false,
    dropzone: undefined,
    selectedType: "",
    availableCountries: [],
    selectedCountry: "Cargando...",
    AllDataFechas: false,
    selectedCountryCode: "",
    userId: "",
    page: 0,
    pagesModal: 0,
    pagesModalI: 0,
    rowsPerPage: 20,

    /** Pagination Modal clients */
    totalClientsException: 0,
    currentPage: 0,
    clientsExceptionCO: [],
    arrayNumPage: [],
    /** */

    consolidate: "",
    pageModalEx: [],
    dateStart: new Date().setDate(new Date().getDate() - 1),
    dateEnd: new Date(),
    dateStartName: "",
    dateEndName: "",
    searchInput: "",
    searchInputModal: "",
    modalOppen: false,
    modalClose: false,
    modalTableColumns: [
      "ID",
      "Cliente",
      "Gerencia de ventas",
      "UEN",
      "Canal",
      "Fecha Inicio",
      "Fecha Fin",
    ],
    modalTableInclusionsColumns: [
      "ID",
      "Cliente",
      "Gerencia de ventas",
      "UEN",
      "Canal",
    ],
    idRowSkuForModal: "",
    messageDounloadModal: "",
    totalClients: "",
    affectedAccounts: 0,
    openModalDounload: false,
    parstToDownload: "",
    end_date: null,
    start_date: null,
    batchIdModal: "",
    modalGeneral: false,
    messageGeneral: "Descargando Archivo",
    modalGeneralError: false,
  };

  componentDidMount() {
    //this.fetchCountries();
    const userCountry = window.sessionStorage.getItem(
      "maz_abi_digitalsalesportal_front_copec_user_country"
    );
    const userCountryCode = window.sessionStorage.getItem(
      "maz_abi_digitalsalesportal_front_copec_user_country_code"
    );
    this.handleCountryUpdate(userCountry, userCountryCode);
    const userID = document.getElementById("exclution-data-user-id").value;
    this.setState({
      userId: userID !== "" ? userID : "undefinedUser",
    });
  }

  fetchLoader = async ({ country, dateValue, event }) => {
    const selectedCountryCode =
      typeof country !== "undefined" ? country : this.state.selectedCountryCode;
    const dateStart = new Date(
      dateValue !== null && event === "start" ? dateValue : this.state.dateStart
    );
    let startDate = `${
      dateStart.getMonth() + 1
    }/${dateStart.getDate()}/${dateStart.getFullYear()}`;
    const dateEnd = new Date(
      dateValue !== null && event === "end" ? dateValue : this.state.dateEnd
    );
    let endDate = `${
      dateEnd.getMonth() + 1
    }/${dateEnd.getDate()}/${dateEnd.getFullYear()}`;

    if (event === null) {
      endDate = null;
      startDate = null;
    }
    this.setState({
      rowsSKU: [],
      rowsExclutions: [],
      rowsPromotions: [],
      consolidate: "",
      rows: [],
      dateStartName: startDate,
      dateEndName: endDate,
    });

    let serviceURL = env.REACT_APP_SERVICES_GET_ALL_EXCLUTIONS;
    serviceURL = serviceURL.replace("<countryCode>", this.props.countriesCode);
    serviceURL = serviceURL.replace("<dateStart>", startDate);
    serviceURL = serviceURL.replace("<dateEnd>", endDate);

    if (selectedCountryCode !== "0") {
      await fetchAPI({
        protocol: "GET",
        service: serviceURL,
        params: {
          codeCountry: selectedCountryCode,
        },
        // service: `${serviceAllExclusionsForDate}${this.props.countriesCode}?start=${startDate}&end=${endDate}`,
        callbackThen: (response) => {
          const arr = [];
          for (var rows in response) {
            const row = response[rows];
            row.product_description =
              row.product_description === null ? "" : row.product_description;
            row.type = "Consolidation Exclusions";
            arr.push(row);
          }
          this.setState({
            rowsSKU: arr,
            rows: arr,
          });
        },
      });
    }
  };

  dataFech = async ({ country, dateValue, event }) => {
    const selectedCountryCode =
      typeof country !== "undefined" ? country : this.state.selectedCountryCode;
    const dateStart = new Date(
      dateValue !== null && event === "start" ? dateValue : this.state.dateStart
    );
    const startDate = `${
      dateStart.getMonth() + 1
    }/${dateStart.getDate()}/${dateStart.getFullYear()}`;
    const dateEnd = new Date(
      dateValue !== null && event === "end" ? dateValue : this.state.dateEnd
    );
    const endDate = `${
      dateEnd.getMonth() + 1
    }/${dateEnd.getDate()}/${dateEnd.getFullYear()}`;

    this.setState({
      rowsSKU: [],
      rowsExclutions: [],
      rowsPromotions: [],
      consolidate: "",
      rows: [],
      dateStartName: startDate,
      dateEndName: endDate,
    });

    let serviceURL = env.REACT_APP_SERVICES_GET_ALL_EXCLUTIONS;
    serviceURL = serviceURL.replace("<countryCode>", this.props.countriesCode);
    serviceURL = serviceURL.replace("<dateStart>", startDate);
    serviceURL = serviceURL.replace("<dateEnd>", endDate);

    if (selectedCountryCode !== "0") {
      fetchAPI({
        protocol: "GET",
        service: serviceURL,
        params: {
          codeCountry: selectedCountryCode,
        },
        // service: `${serviceAllExclusionsForDate}${this.props.countriesCode}?start=${startDate}&end=${endDate}`,
        callbackThen: (response) => {
          const arr = [];
          for (var rows in response) {
            const row = response[rows];
            row.product_description =
              row.product_description === null ? "" : row.product_description;
            row.type = "Consolidation Exclusions";
            arr.push(row);
          }
          this.setState({
            rowsSKU: arr,
            rows: arr,
          });
        },
      });
    }
  };

  closeModalGeneral = () => {
    this.setState({ modalGeneral: false });
  };

  toggleDialogOpen() {
    this.setState({
      dialogOpen: !this.state.dialogOpen,
      dialogSectionFile: true,
    });
  }

  handleChangeD(checked) {
    this.setState({ checked });
    if (checked) {
      this.fetchClientsExceptions(
        this.state.batchIdModal,
        this.state.currentPage
      );
    }
  }

  handleDownload = async (
    e,
    f,
    c,
    clients,
    handleParts = { onlyParts: false, exception: false }
  ) => {
    switch (e) {
      case "allExclutions":
        this.setState({
          modalGeneral: true,
          messageGeneral: "Descargando archivo",
        });
        break;
      case "exclutionsForProduct":
        this.setState({
          modalGeneral: true,
          messageGeneral: "Generando partes",
        });
        break;

      default:
        this.setState({
          modalGeneral: true,
          messageGeneral: "Actualizando Información",
        });
        break;
    }
    //f es el id lote, c es el total filas por pagina, clients son el total de clientes impactados
    const message = `Se encontraron ${clients} clientes |¿Cómo desea descargarlos?`;
    let messageModify = message.split("|");

    const dateStart = new Date(this.state.dateStart);
    const startDate = `${
      dateStart.getMonth() + 1
    }/${dateStart.getDate()}/${dateStart.getFullYear()}`;
    const dateEnd = new Date(this.state.dateEnd);
    const endDate = `${
      dateEnd.getMonth() + 1
    }/${dateEnd.getDate()}/${dateEnd.getFullYear()}`;
    if (c !== 0) {
      if (
        !handleParts.onlyParts &&
        this.state.checked &&
        this.props.countriesCode !== "mdcolombia"
      ) {
        let serviceURL =
          env.REACT_APP_SERVICES_GET_PARST_CONSOLIDATE_DOWNLOAD_ALL;
        serviceURL = serviceURL.replace(
          "<countryCode>",
          this.props.countriesCode
        );
        serviceURL = serviceURL.replace("<bacthId>", f);
        if (startDate && endDate) {
          fetchAPI({
            protocol: "GET",
            params: {
              codeCountry: this.props.countriesCode,
            },
            service: serviceURL,
            download: true,
            codeCountry: this.props.countriesCode,
            archiveName: `consolidadoExclusiones ${this.state.dateStartName} - ${this.state.dateEndName} - Inclusiones.csv`,
            // service: `${serviceAllExclusionsForDate}mdcolombia/download?start=${startDate}&end=${endDate}`,
            callbackThen: (response) => {
              this.setState({
                consolidate: response,
                modalGeneral: false,
                idRowSkuForModal: f,
              });
            },
          });
        }
      } else if (e === "allExclutions") {
        let serviceURL = env.REACT_APP_SERVICES_DOWNLOAD_ALL_EXCLUTIONS;
        serviceURL = serviceURL.replace(
          "<countryCode>",
          this.props.countriesCode
        );
        console.log("Fechas", this.state.dateStartName);
        if (this.state.AllDataFechas) {
          serviceURL = serviceURL.replace("<dateStart>", this.state.dateEnd);
          serviceURL = serviceURL.replace("<dateEnd>", this.state.dateStart);
        }
        serviceURL = serviceURL.replace("<dateStart>", startDate);
        serviceURL = serviceURL.replace("<dateEnd>", endDate);
        if (startDate && endDate) {
          fetchAPI({
            protocol: "GET",
            params: {
              codeCountry: this.props.countriesCode,
            },
            service: serviceURL,
            download: true,
            codeCountry: this.props.countriesCode,
            archiveName: `consolidadoExclusiones ${this.state.dateStartName} - ${this.state.dateEndName}.csv`,
            callbackThen: (response) => {
              this.setState({
                consolidate: response,
                modalGeneral: false,
              });
            },
          });
        }
      } else {
        let serviceURL = !handleParts.exception
          ? env.REACT_APP_SERVICES_GET_PARST_CONSOLIDATE
          : env.REACT_APP_SERVICES_GET_PARST_CONSOLIDATE_EXCEPTION;

        serviceURL = serviceURL.replace(
          "<countryCode>",
          this.props.countriesCode
        );
        serviceURL = serviceURL.replace("<bacthId>", f);

        await fetchAPI({
          protocol: "GET",
          service: serviceURL,
          // download: true,
          codeCountry: this.props.countriesCode,
          archiveName: `consolidadoExclusiones ${this.state.dateStartName} - ${this.state.dateEndName} - Exclusiones.csv`,
          // service: `${serviceAllExclusionsForDate}mdcolombia/download?start=${startDate}&end=${endDate}`,
          callbackThen: (response) => {
            this.setState({
              modalGeneral: false,
              idRowSkuForModal: f,
            });
            if (response)
              if (response.length > 0) {
                this.setState({
                  parstToDownload: response,
                  messageDounloadModal: messageModify,
                  openModalDounload: true,
                });
              } else {
                this.setState({
                  modalGeneralError: true,
                  messageGeneral: "Sin clientes encontrados",
                  iconTypeGeneral: "info",
                });
              }
          },
        });
      }
    }
  };

  handleDialogClose = () => {
    this.toggleDialogOpen();
    this.setState({
      loaderFiles: [],
      idRowSkuForModal: "",
    });
  };

  handleDropdown = (selectedValue, evt) => {
    this.setState({
      selectedCountry: evt.target.outerText,
      selectedCountryCode: selectedValue,
    });

    this.fetchLoader({
      country: selectedValue,
    });
  };

  handleCountryUpdate = (countryName, countryCode) => {
    this.setState({
      selectedCountry: countryName,
      selectedCountryCode: countryCode,
    });

    this.fetchLoader({
      country: countryCode,
    });
  };

  getBase64(file) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });
  }

  handleLoadingFileCloseButton = () => {
    this.toggleDialogOpen();
    this.setState({
      dialogSectionFile: true,
      dialogLoadingFile: false,
      esponseFileProgress: "",
      fileProgress: 0,
    });
  };

  handleChangePage = (event, newPage) => {
    this.setState({
      page: newPage,
    });
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      rowsPerPage: +event.target.value,
      page: 0,
    });
  };

  selectPage = (e) => {
    const page = e.target.dataset.page;
    const pageNumber = parseInt(page) - 1;
    this.setState({
      page: pageNumber,
    });
    this.reloadDataTable();
  };

  reloadDataTable = () => {
    const tempRows = this.state.rows;
    this.setState({
      rows: [],
    });
    setTimeout(() => {
      this.setState({
        rows: tempRows,
      });
    }, 500);
  };

  selectPageModal = (e) => {
    const page = e.target.dataset.page;
    const pageNumber = parseInt(page) - 1;
    this.setState({
      pagesModal: pageNumber,
    });
    this.onClickModalDetail(
      this.state.idRowSkuForModal,
      this.state.searchInputModal !== "" ? this.state.searchInputModal : "",
      pageNumber
    );
  };

  selectPageModalI = (e) => {
    const page = e.target.dataset.page;
    const pageNumber = parseInt(page) - 1;
    this.setState({
      pagesModalI: pageNumber,
    });
  };

  previousPage = () => {
    if (this.state.page > 0) {
      this.setState({
        page: this.state.page - 1,
      });
      this.reloadDataTable();
    }
  };

  nextPage = () => {
    const totalRows = this.state.rowsSKU.concat(
      this.state.rowsExclutions,
      this.state.rowsPromotions
    );
    const pageCount = Math.ceil(totalRows.length / this.state.rowsPerPage);
    if (this.state.page < pageCount - 1) {
      this.setState({
        page: this.state.page + 1,
      });
    }
    this.reloadDataTable();
  };

  previousPageModal = () => {
    if (this.state.pagesModal > 0) {
      this.setState({
        pagesModal: this.state.pagesModal - 1,
      });
      this.onClickModalDetail(
        this.state.idRowSkuForModal,
        this.state.searchInputModal !== "" ? this.state.searchInputModal : "",
        this.state.pagesModal - 1
      );
    }
  };

  previousPageModalException = () => {
    if (this.state.currentPage > 0) {
      this.setState({
        currentPage: this.state.currentPage - 1,
      });
      this.fetchClientsExceptions(
        this.state.batchIdModal,
        this.state.currentPage - 1
      );
    }
  };

  selectPageModalException = (e) => {
    const page = e.target.dataset.page;
    this.setState({
      currentPage: page - 1,
    });
    this.fetchClientsExceptions(this.state.batchIdModal, page - 1);
  };

  nextPageModalException = () => {
    if (this.state.currentPage < this.state.arrayNumPage.length - 1) {
      this.setState({
        currentPage: this.state.currentPage + 1,
      });
      this.fetchClientsExceptions(
        this.state.batchIdModal,
        this.state.currentPage + 1
      );
    }
  };

  previousPageModalI = () => {
    if (this.state.pagesModalI > 0) {
      this.setState({
        pagesModalI: this.state.pagesModalI - 1,
      });
    }
  };

  nextPageModal = () => {
    const totalRowsModal = this.state.rowsSKUForModal;
    const pageCount = totalRowsModal.pages;
    if (this.state.pagesModal < pageCount - 1) {
      this.setState({
        pagesModal: this.state.pagesModal + 1,
      });
      this.onClickModalDetail(
        this.state.idRowSkuForModal,
        this.state.searchInputModal !== "" ? this.state.searchInputModal : "",
        this.state.pagesModal + 1
      );
    }
  };

  nextPageModalI = () => {
    const totalRowsModal = this.state.rowsSKUForModal;
    const pageCount = totalRowsModal.pages;
    if (this.state.pagesModalI < pageCount - 1) {
      this.setState({
        pagesModalI: this.state.pagesModalI + 1,
      });
    }
  };

  clickBoton = () => {
    this.setState({
      dateEnd: null,
      dateStart: null,
      AllDataFechas: true,
    });
    console.log("FECHAS", this.state.dateEnd);
    this.fetchLoader({
      country: this.props.countriesCode,
      dateValue: null,
      event: null,
    });
  };

  handleDateChange = (e) => (value) => {
    this.setState({
      AllDataFechas: false,
    });
    this.setState(
      e === "start"
        ? {
            dateStart: value,
          }
        : {
            dateEnd: value,
          }
    );
    if (e === "end" || e === "start") {
      this.fetchLoader({
        country: this.props.countriesCode,
        dateValue: value,
        event: e,
      });
    }
  };

  onChangeSearchInput = async (e) => {
    e.persist();
    await this.setState({
      searchInput: e.target.value.toString().toLowerCase(),
    });
    this.filterItems();
  };

  filterItems = () => {
    var search = this.state.rowsSKU.filter((item) => {
      if (item.product) {
        if (
          item.product.includes(this.state.searchInput) ||
          item.product_description
            .toLowerCase()
            .includes(this.state.searchInput.toLocaleLowerCase())
        ) {
          return item;
        }
      }
    });
    this.setState({ rows: [], page: 0 });
    this.setState({ rows: search });
  };

  onChangeSearchInputModal = async (e) => {
    e.persist();
    await this.setState({
      searchInputModal: e.target.value.toString().toLowerCase(),
    });

    if (this.state.checked && this.props.countriesCode !== "mdcolombia") {
      const newPages = [];
      let divR = 0;
      if (this.state.modalOppen === true) {
        divR =
          this.state.rowsData.rule.clients_exception === undefined
            ? 0
            : this.state.rowsData.rule.clients_exception.filter((ele) => {
                if (
                  this.state.searchInputModal &&
                  this.state.searchInputModal !== "" &&
                  this.state.searchInputModal !== ""
                )
                  return (
                    ele.cust_no
                      .toLowerCase()
                      .includes(this.state.searchInputModal) ||
                    ele.name.toLowerCase().includes(this.state.searchInputModal)
                  );
                return true;
              }).length / 20;

        for (let i = 1; i <= divR - 1; i++) {
          newPages.push(i);
        }
      }

      this.setState({
        pageModalEx: newPages,
      });
    }
  };

  filterItemsModal = async (event) => {
    if (event.key === "Enter")
      if (!this.state.checked) {
        this.onClickModalDetail(
          this.state.idRowSkuForModal,
          this.state.searchInputModal
        );
        this.setState({
          pagesModal: 0,
        });
      } else {
        this.setState({
          currentPage: 0,
        });
        this.fetchClientsExceptions(this.state.batchIdModal, 0);
      }
  };

  todoModal = (id, e, f) => {
    this.onClickModalDetail(id, e);
    this.setState({
      batchIdModal: id,
      pagesModalI: 0,
      pagesModal: 0,
      pageModalEx: [],
      checked: false,
    });
  };

  recursiveConstrucObjClients = async (data, row, index, ret) => {
    if (row.hasOwnProperty("start_date"))
      row.start_date = row.start_date
        ? new Date(row.start_date + "T00:00:00").toLocaleDateString("en-US")
        : row.start_date;
    if (row.hasOwnProperty("exp_date"))
      row.exp_date = row.exp_date
        ? new Date(row.exp_date + "T00:00:00").toLocaleDateString("en-US")
        : row.exp_date;
    ret.push(row);
    if (index + 1 < data.length)
      return this.recursiveConstrucObjClients(
        data,
        data[index + 1],
        index + 1,
        ret
      );
    return ret;
  };

  onClickModalDetail = (id, e, f) => {
    this.setState({
      modalOppen: true,
      modalClose: false,
      rowsSKUForModal: [],
      rowsData: [],
      rowsForModal: [],
      idRowSkuForModal: id,
    });

    let serviceURL =
      typeof e !== "object" || e === ""
        ? env.REACT_APP_SERVICES_GET_ALL_EXCLUTIONS_PRODUCT_COUNTRY +
          "&search=<option>"
        : env.REACT_APP_SERVICES_GET_ALL_EXCLUTIONS_PRODUCT_COUNTRY;
    serviceURL = serviceURL.replace("<countryCode>", this.props.countriesCode);
    serviceURL = serviceURL.replace("<bacthId>", id);
    if (f === undefined || f === "") {
      this.setState({ pagesModal: 0 });
      serviceURL = serviceURL.replace("<pageNumber>", 1);
    } else {
      serviceURL = serviceURL.replace("<pageNumber>", f + 1);
    }
    serviceURL = serviceURL.replace("<limitForPage>", 20);
    serviceURL = serviceURL.replace("<option>", e);

    fetchAPI({
      protocol: "GET",
      service: serviceURL,
      params: {
        codeCountry: this.props.countriesCode,
      },
      // service: `${serviceAllExclusionsForDate}/${id}`,
      callbackThen: async (response) => {
        let accounts = [];
        if (response.hasOwnProperty("accounts") && response.accounts.length > 0)
          accounts = await this.recursiveConstrucObjClients(
            response.accounts,
            response.accounts[0],
            0,
            []
          );

        if (this.state.modalOppen === true) {
          const divR =
            response.rule.clients_exception === undefined
              ? 0
              : response.rule.clients_exception.length / 20;

          for (let i = 1; i <= divR - 1; i++) {
            this.state.pageModalEx.push(i);
          }
        }

        this.setState({
          rowsSKUForModal: response,
          rowsData: response,
          rowsForModal: accounts,
          pageModalEx: this.state.pageModalEx,
        });
      },
    });
  };

  fetchClientsExceptions = async (batchId, page) => {
    this.setState({
      clientsExceptionCO: [],
    });

    let serviceURL = env.REACT_APP_SERVICES_INFINITI_CLIENTS;
    
    serviceURL = serviceURL.replace(
      "<countryCode>",
      this.props.countriesCode
    );
    serviceURL = serviceURL.replace("<batchId>", batchId);
    serviceURL = serviceURL.replace(
      "<page>",
      page === undefined || page === "" ? 1 : page + 1
    );
    serviceURL = serviceURL.replace("<limit>", 20);
    serviceURL = serviceURL.replace("<exclusion>", false);
    serviceURL += "&consolidate=true";

    if (this.state.searchInputModal && this.state.searchInputModal.length > 0)
      serviceURL += `&search=${this.state.searchInputModal.toLocaleLowerCase()}`;

    await fetchAPI({
      protocol: "GET",
      service: serviceURL,
      params: {
        codeCountry: this.props.countriesCode,
      },
      callbackThen: async (response) => {
        let { accounts, dataPaginate, totalAcc } = response;
        if (accounts.length > 0)
          accounts = await this.recursiveConstrucObjClients(
            accounts,
            accounts[0],
            0,
            []
          );

        const arr = [];
        for (let i = 1; i <= dataPaginate.pages; i++) {
          arr.push(i);
        }

        this.setState({
          totalClientsException: totalAcc,
          clientsExceptionCO: accounts,
          arrayNumPage: arr,
        });
      },
    });
  };

  onCloseModal = () => {
    this.setState({
      modalOppen: false,
      modalClose: true,
      rowsForModal: [],
      searchInputModal: "",
    });
  };

  funtionDateFormat = (str) => {
    var date = new Date(str);
    date.setHours(date.getHours());
    return [
      this.padTo2Digits(date.getDate()),
      this.padTo2Digits(date.getMonth() + 1),
      date.getFullYear(),
    ].join("/");
  };

  padTo2Digits(num) {
    return num.toString().padStart(2, "0");
  }

  dounloadSecment() {
    this.setState({
      openModalDounload: false,
    });
  }

  handleChangeDateModal(option, data, index, e, row, idRowSkuForModal) {
    // if(option === "start") return
    // console.log("🚀 ~ file: DashboardConsolExclusions.js ~ line 541 ~ DashboardLoader ~ handleChangeDateModal ~ idRowSkuForModal", idRowSkuForModal)
    let rows = row;
    let serviceURL = env.REACT_APP_SERVICES_POST_DATES_MODALEXCLUSIONS;
    serviceURL = serviceURL.replace("<countryCode>", this.props.countriesCode);
    serviceURL = serviceURL.replace("<bathId>", idRowSkuForModal);

    if (option === "end") {
      rows[index] = data;
      // console.log("🚀 ~ file: DashboardConsolExclusions.js ~ line 550 ~ DashboardLoader ~ handleChangeDateModal ~ rows[index]", rows[index])
      data.exp_date = e;
      this.setState({
        rowsForModal: rows,
        newDateEnd: e,
      });
    } else {
      rows[index] = data;
      data.start_date = e;

      this.setState({
        rowsForModal: rows,
        newDateStart: e,
      });
    }

    let params = {
      clientId: rows[index].client_id,
      expDate: data.exp_date
        ? new Date(data.exp_date).toLocaleDateString("en-US")
        : null,
      startDate: data.start_date
        ? new Date(data.start_date).toLocaleDateString("en-US")
        : null,
    };
    fetchAPI({
      protocol: "POST",
      service: serviceURL,
      params: params,
      codeCountry: this.props.countriesCode,
      callbackThen: (response) => {
        // this.setState({
        //   rowsSKUForModal: response,
        //   rowsForModal: response.accounts,
        // });
      },
    });
  }

  render() {
    const { tableColumns } = this.state;

    const StyledTableCell = withStyles((theme) => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: "#FFFF00",
        fontFamily: "Roboto",
        fontstyle: "normal",
        fontWeight: "normal",
        fontSize: 18,
        padding: "8px 30px",
      },
      body: {
        fontSize: 14,
        padding: "9px 30px",
        maxHeight: "555px",
      },
    }))(TableCell);

    const StyledTableCellModal = withStyles((theme) => ({
      head: {
        backgroundColor: theme.palette.common.black,
        color: "#FFFF00",
        fontFamily: "Roboto",
        fontstyle: "normal",
        fontWeight: "normal",
        fontSize: 18,
        padding: "20px 30px",
      },
      body: {
        fontSize: 14,
        padding: "15px 30px",
        maxHeight: "50rem",
      },
    }))(TableCell);

    const StyledTableRow = withStyles((theme) => ({
      root: {
        "&:nth-of-type(odd)": {
          backgroundColor: theme.palette.action.hover,
        },
      },
    }))(TableRow);

    // const totalRows = this.state.rowsSKU.concat(this.state.rowsExclutions, this.state.rowsPromotions);
    let totalRows = this.state.rows.sort((a, b) => {
      if (!a.updatedAt) return -1;
      if (
        new Date(
          a.updatedAt.substring(3, 5) +
            "/" +
            a.updatedAt.substring(0, 2) +
            "/" +
            a.updatedAt.substring(6)
        ) <
        new Date(
          b.updatedAt.substring(3, 5) +
            "/" +
            b.updatedAt.substring(0, 2) +
            "/" +
            b.updatedAt.substring(6)
        )
      ) {
        return 1;
      }
      if (
        new Date(
          a.updatedAt.substring(3, 5) +
            "/" +
            a.updatedAt.substring(0, 2) +
            "/" +
            a.updatedAt.substring(6)
        ) >
        new Date(
          b.updatedAt.substring(3, 5) +
            "/" +
            b.updatedAt.substring(0, 2) +
            "/" +
            b.updatedAt.substring(6)
        )
      ) {
        return -1;
      }
      // a debe ser igual b
      return 0;
    });
    const totalRowsModal = this.state.rowsSKUForModal;
    totalRows.sort(function (a, b) {
      return new Date(b.created_at) - new Date(a.created_at);
    });

    const pageCount = Math.ceil(totalRows.length / this.state.rowsPerPage);
    let pages = [];

    for (let i = 1; i <= pageCount; i++) {
      pages.push(i);
    }

    const pageCountForModal = totalRowsModal.pages;
    let pagesModal = [];
    let pageModalEx = [];
    let initialPage = [];

    this.totalRowsModalForPage = (page) => {
      if (page > 8) {
        for (let i = 1; i <= 8; i++) {
          initialPage.push(i);
        }
      }
    };
    for (let i = 1; i <= pageCountForModal; i++) {
      pagesModal.push(i);
    }

    const dateStart = this.state.dateStart
      ? new Date(this.state.dateStart)
      : null;
    const dateEnd = this.state.dateEnd ? new Date(this.state.dateEnd) : null;

    const showModalPartsDataTable = (bacthId, totalAcc) => {
      return (
        <DownloadIcon
          className={"onPointer"}
          onClick={(e) =>
            this.handleDownload(
              "exclutionsForProduct",
              bacthId,
              totalAcc,
              totalAcc,
              { onlyParts: true }
            )
          }
        ></DownloadIcon>
      );
    };

    const dialogTableExcepciones = () => {
      return (
        <DialogContent style={{ height: "400rem", width: "70rem" }}>
          <div className="loader__table">
            <TableContainer
              component={Paper}
              classes={{ container: { maxHeight: 1000 } }}
              sx={{ minWidth: 650 }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {this.state.modalTableInclusionsColumns.map(
                      (element, key) => (
                        <StyledTableCellModal align="left" key={key}>
                          {element}
                        </StyledTableCellModal>
                      )
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.rowsSKUForModal?.rule?.clients_exception &&
                  this.state.rowsSKUForModal.rule.clients_exception.length >
                    0 ? (
                    this.state.rowsSKUForModal.rule.clients_exception
                      .filter((ele) => {
                        if (
                          this.state.searchInputModal &&
                          this.state.searchInputModal !== "" &&
                          this.state.searchInputModal !== ""
                        )
                          return (
                            ele.cust_no
                              .toLowerCase()
                              .includes(this.state.searchInputModal) ||
                            ele.name
                              .toLowerCase()
                              .includes(this.state.searchInputModal)
                          );
                        return true;
                      })
                      .slice(
                        this.state.pagesModalI * 20,
                        this.state.pagesModalI * 20 + 20
                      )
                      .map((row, index) => (
                        <StyledTableRow>
                          <StyledTableCellModal
                            align={row.cust_no === null ? "center" : "left"}
                          >
                            {row.cust_no === null ? "-" : row.cust_no}
                          </StyledTableCellModal>
                          <StyledTableCellModal
                            align={row.name === null ? "center" : "left"}
                          >
                            {row.name === null ? "-" : row.name}
                          </StyledTableCellModal>
                          <StyledTableCellModal
                            align={row.gerencia === null ? "center" : "left"}
                          >
                            {row.gerencia === null ? "-" : row.gerencia}
                          </StyledTableCellModal>
                          <StyledTableCellModal
                            align={row.uen === null ? "center" : "left"}
                          >
                            {row.uen === null ? "-" : row.uen}
                          </StyledTableCellModal>
                          <StyledTableCellModal
                            align={row.channel === null ? "center" : "left"}
                          >
                            {row.channel === null ? "-" : row.channel}
                          </StyledTableCellModal>
                        </StyledTableRow>
                      ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCellModal colSpan={7} align="center">
                        No hay clientes impactados Inclusiones
                      </StyledTableCellModal>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div style={{ marginTop: "70px" }} className="loader__actions__modal">
            <div style={{ marginLeft: "30%" }} className="loader__pagerModal">
              <Paginador
                pagesModal={this.state.pageModalEx}
                pagesModalState={this.state.pagesModalI}
                previousPageModal={this.previousPageModalI}
                selectPageModal={this.selectPageModalI}
                nextPageModal={this.nextPageModalI}
              />
              {/* <DetailExclusions /> */}
            </div>
            {console.log("totalRow", totalRowsModal)}
            <DropdownButton
              className="loader__dropdown yellowModall"
              onClick={(e) =>
                totalRowsModal?.rule?.clients_exception &&
                totalRowsModal.rule.clients_exception.length > 0
                  ? this.handleDownload(
                      "exclutionsForProduct",
                      this.state.idRowSkuForModal,
                      totalRowsModal.affectedAccounts,
                      pageCountForModal
                    )
                  : (e) => {}
              }
              title={this.state.labelDropdown}
              disabled={
                !(
                  totalRowsModal?.rule?.clients_exception &&
                  totalRowsModal.rule.clients_exception.length > 0
                )
              }
            ></DropdownButton>
          </div>
        </DialogContent>
      );
    };

    const dialogTableExcepcionsColombia = () => {
      return (
        <DialogContent style={{ height: "400rem", width: "70rem" }}>
          <div className="loader__table">
            <TableContainer
              component={Paper}
              classes={{ container: { maxHeight: 1000 } }}
              sx={{ minWidth: 650 }}
            >
              <Table stickyHeader aria-label="sticky table">
                <TableHead>
                  <TableRow>
                    {this.state.modalTableInclusionsColumns.map(
                      (element, key) => (
                        <StyledTableCellModal align="left" key={key}>
                          {element}
                        </StyledTableCellModal>
                      )
                    )}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.state?.clientsExceptionCO?.length > 0 ? (
                    this.state?.clientsExceptionCO.map((row, index) => (
                      <StyledTableRow>
                        <StyledTableCellModal
                          align={row.cust_no === null ? "center" : "left"}
                        >
                          {row.cust_no === null ? "-" : row.cust_no}
                        </StyledTableCellModal>
                        <StyledTableCellModal
                          align={row.name === null ? "center" : "left"}
                        >
                          {row.name === null ? "-" : row.name}
                        </StyledTableCellModal>
                        <StyledTableCellModal
                          align={row.gerencia === null ? "center" : "left"}
                        >
                          {row.gerencia === null ? "-" : row.gerencia}
                        </StyledTableCellModal>
                        <StyledTableCellModal
                          align={row.uen === null ? "center" : "left"}
                        >
                          {row.uen === null ? "-" : row.uen}
                        </StyledTableCellModal>
                        <StyledTableCellModal
                          align={row.channel === null ? "center" : "left"}
                        >
                          {row.channel === null ? "-" : row.channel}
                        </StyledTableCellModal>
                      </StyledTableRow>
                    ))
                  ) : (
                    <StyledTableRow>
                      <StyledTableCellModal colSpan={7} align="center">
                        No hay clientes impactados Inclusiones
                      </StyledTableCellModal>
                    </StyledTableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div style={{ marginTop: "70px" }} className="loader__actions__modal">
            <div style={{ marginLeft: "30%" }} className="loader__pagerModal">
              <Paginador
                pagesModal={this.state.arrayNumPage}
                pagesModalState={this.state.currentPage}
                previousPageModal={this.previousPageModalException}
                selectPageModal={this.selectPageModalException}
                nextPageModal={this.nextPageModalException}
              />
              {/* <DetailExclusions /> */}
            </div>
            <DropdownButton
              className="loader__dropdown yellowModall"
              onClick={(e) =>
                this.state?.clientsExceptionCO &&
                this.state?.clientsExceptionCO.length > 0
                  ? this.handleDownload(
                      "exclutionsForProduct",
                      this.state.idRowSkuForModal,
                      totalRowsModal.affectedAccounts,
                      pageCountForModal,
                      { exception: true }
                    )
                  : (e) => {}
              }
              title={this.state.labelDropdown}
              disabled={
                !(
                  this.state.clientsExceptionCO &&
                  this.state.clientsExceptionCO.length > 0
                )
              }
            ></DropdownButton>
          </div>
        </DialogContent>
      );
    };

    return (
      <div className="loader">
        <Grid
          container
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          justifyContent="space-between"
        >
          <Grid container item lg={12}>
            <Grid item xs={12} sm={12} md={4} lg={6}>
              <div className="loader__title">
                {this.state.dateStart && this.state.dateEnd
                  ? `${dateStart.getDate()} ${
                      dateStart.getMonth() + 1 === 1
                        ? "Enero"
                        : dateStart.getMonth() + 1 === 2
                        ? "Febrero"
                        : dateStart.getMonth() + 1 === 3
                        ? "Marzo"
                        : dateStart.getMonth() + 1 === 4
                        ? "Abril"
                        : dateStart.getMonth() + 1 === 5
                        ? "Mayo"
                        : dateStart.getMonth() + 1 === 6
                        ? "Junio"
                        : dateStart.getMonth() + 1 === 7
                        ? "Julio"
                        : dateStart.getMonth() + 1 === 8
                        ? "Agosto"
                        : dateStart.getMonth() + 1 === 9
                        ? "Septiembre"
                        : dateStart.getMonth() + 1 === 10
                        ? "Octubre"
                        : dateStart.getMonth() + 1 === 11
                        ? "Noviembre"
                        : "Diciembre"
                    } a ${dateEnd.getDate()} de ${
                      dateEnd.getMonth() + 1 === 1
                        ? "Enero"
                        : dateEnd.getMonth() + 1 === 2
                        ? "Febrero"
                        : dateEnd.getMonth() + 1 === 3
                        ? "Marzo"
                        : dateEnd.getMonth() + 1 === 4
                        ? "Abril"
                        : dateEnd.getMonth() + 1 === 5
                        ? "Mayo"
                        : dateEnd.getMonth() + 1 === 6
                        ? "Junio"
                        : dateEnd.getMonth() + 1 === 7
                        ? "Julio"
                        : dateEnd.getMonth() + 1 === 8
                        ? "Agosto"
                        : dateEnd.getMonth() + 1 === 9
                        ? "Septiembre"
                        : dateEnd.getMonth() + 1 === 10
                        ? "Octubre"
                        : dateEnd.getMonth() + 1 === 11
                        ? "Noviembre"
                        : "Diciembre"
                    }  - Periodo`
                  : "- Periodo"}
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={8}
              lg={6}
              style={{ display: "flex" }}
              justifyContent="space-between"
            >
              <TextField
                label="Sku/Descripcion..."
                // icon="SearchIcon"
                className="textField"
                name="busqueda"
                id="search"
                sx={{
                  width: "20ch",
                }}
                value={this.state.searchInput}
                onChange={this.onChangeSearchInput}
                style={{
                  top: "-4px",
                }}
                // InputProps={{
                //   endAdornment: (
                //     <IconButton>
                //       <SearchIcon />
                //     </IconButton>
                //   ),
                // }}
              />
              <MuiPickersUtilsProvider
                utils={DateFnsUtils}
                style={{ justifyContent: "center" }}
              >
                <KeyboardDatePicker
                  autoOk
                  label="Fecha Inicio"
                  variant="inline"
                  inputVariant="outlined"
                  disableToolbar
                  format="dd/MM/yyyy"
                  maxDate={dateEnd || new Date()}
                  value={dateStart}
                  onChange={this.handleDateChange("start")}
                />
                <KeyboardDatePicker
                  autoOk
                  variant="inline"
                  inputVariant="outlined"
                  label="Fecha Fin"
                  // disableFuture // desactiva dias futuros
                  disableToolbar
                  format="dd/MM/yyyy"
                  minDate={
                    dateStart || new Date().setDate(new Date().getDate() - 1)
                  }
                  value={dateEnd}
                  onChange={this.handleDateChange("end")}
                />
                <Button
                  onClick={this.clickBoton}
                  className="stylesVerAll"
                  endIcon={<EventIcon />}
                >
                  Ver Todo
                </Button>
              </MuiPickersUtilsProvider>
            </Grid>
          </Grid>
        </Grid>
        <div className="loader__table">
          <DataTable
            StyledTableRow={StyledTableRow}
            StyledTableCell={StyledTableCell}
            componentType={Paper}
            classStyle={{ container: { maxHeight: 400 } }}
            head={this.state.tableColumns}
            body={totalRows}
            dateStart={dateStart}
            dateEnd={dateEnd}
            page={this.state.page}
            rowsPerPage={this.state.rowsPerPage}
            selectedCountryCode={this.state.selectedCountryCode}
            dateRow={true}
            funtionDateFormat={this.funtionDateFormat}
            todoModal={this.todoModal}
            totalColumsConsol={tableColumns.length}
            countryCode={this.props.countriesCode}
            pruebaStateBatchId={(e) => this.setState({ batchIdModal: e })}
            showModalParts={showModalPartsDataTable}
          />
        </div>
        <div className="loader__actions">
          <div className="loader__pager">
            <Paginador
              pagesModal={pages}
              pagesModalState={this.state.page}
              previousPageModal={this.previousPage}
              selectPageModal={this.selectPage}
              nextPageModal={this.nextPage}
            />
          </div>
          <Dropdown
            className="loader__dropdown yellowDashExclusions"
            onClick={(e) =>
              this.handleDownload("allExclutions", "", null, pageCountForModal)
            }
          >
            <Dropdown.Toggle id="dropdown-basic">
              {this.state.labelDropdown}
            </Dropdown.Toggle>
          </Dropdown>
        </div>
        <DialogHoneyLoad
          opened={this.state.modalGeneral}
          showIcon={true}
          iconType={"updating"}
          message={this.state.messageGeneral}
          buttonCancel={false}
          buttonAccept={false}
          buttonDownload={false}
        />
        <DialogHoneyLoad
          opened={this.state.modalGeneralError}
          showIcon={true}
          iconType={this.state.iconTypeGeneral}
          message={this.state.messageGeneral}
          buttonCancel={false}
          buttonAccept={true}
          buttonAcceptText={"Aceptar"}
          onClickAccept={(e) =>
            this.setState({
              modalGeneralError: false,
            })
          }
          buttonDownload={false}
        />

        {/*Modal de exlusiones*/}
        <Dialog
          onClose={this.onCloseModal}
          open={this.state.modalOppen}
          className="loader__dialogPaperModal"
          fullWidth
          maxWidth="lg"
        >
          <Grid container item xs={12} justifyContent="flex-end">
            <Grid item xs={4}>
              <div className="barraBusqueda">
                <Button
                  id="btn-nquote"
                  className={
                    this.state.checked ? "stylesButton" : "stylesButton_true"
                  }
                  onClick={() => this.handleChangeD(false)}
                >
                  Exclusiones
                </Button>
                <Button
                  id="btn-flex"
                  className="stylesButtons"
                  onClick={() => this.handleChangeD(true)}
                >
                  Excepciones
                </Button>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className="loader__title__detalle">
                {this.state.checked
                  ? `${
                      this.props.countriesCode === "mdcolombia"
                        ? this.state.totalClientsException
                        : totalRowsModal?.rule?.clients_exception?.length || 0
                    }`
                  : totalRowsModal.totalAcc !== 0
                  ? `${totalRowsModal.totalAcc}`
                  : " - "}{" "}
                Clientes impactados
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className="barraBusqueda">
                <TextField
                  label="Buscador"
                  icon="SearchIcon"
                  className="textField"
                  name="busqueda"
                  id="search"
                  sx={{
                    width: "20ch",
                  }}
                  value={this.state.searchInputModal}
                  onChange={this.onChangeSearchInputModal}
                  onKeyUp={this.filterItemsModal}
                  style={{
                    top: "-4px",
                  }}
                  // InputProps={{
                  //   startAdornment: (
                  //     <IconButton>
                  //       <SearchIcon />
                  //     </IconButton>
                  //   ),
                  // }}
                />
              </div>
            </Grid>
          </Grid>
          <span>
            {this.state.checked ? (
              //Inclusiones

              /*this.props.countriesCode === "mdcolombia" ? */
              (
                dialogTableExcepcionsColombia()
              ) 
              /*: (
                dialogTableExcepciones()
              )
              */
            ) : (
              //Exclusiones
              <DialogContent style={{ height: "400rem", width: "70rem" }}>
                <div className="loader__table">
                  {this.state.rowsForModal ? (
                    <TableContainer
                      component={Paper}
                      classes={{ container: { maxHeight: 1000 } }}
                      sx={{ minWidth: 650 }}
                    >
                      <Table stickyHeader aria-label="sticky table">
                        <TableHead>
                          <TableRow>
                            {this.state.modalTableColumns.map(
                              (element, key) => (
                                <StyledTableCellModal align="left" key={key}>
                                  {element}
                                </StyledTableCellModal>
                              )
                            )}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {this.state.rowsForModal.length > 0 ? (
                            this.state.rowsForModal
                              .slice(
                                this.state.page * this.state.rowsPerPage,
                                this.state.page * this.state.rowsPerPage +
                                  this.state.rowsPerPage
                              )
                              .map((row, index) => (
                                <StyledTableRow>
                                  <StyledTableCellModal
                                    align={
                                      row.client_id === null ? "center" : "left"
                                    }
                                  >
                                    {row.client_id === null
                                      ? "-"
                                      : row.client_id}
                                  </StyledTableCellModal>
                                  <StyledTableCellModal
                                    align={
                                      row.client_name === null
                                        ? "center"
                                        : "left"
                                    }
                                  >
                                    {row.client_name === null
                                      ? "-"
                                      : row.client_name}
                                  </StyledTableCellModal>
                                  <StyledTableCellModal
                                    align={
                                      row.gerencia === null ? "center" : "left"
                                    }
                                  >
                                    {row.gerencia === null ? "-" : row.gerencia}
                                  </StyledTableCellModal>
                                  <StyledTableCellModal
                                    align={row.uen === null ? "center" : "left"}
                                  >
                                    {row.uen === null ? "-" : row.uen}
                                  </StyledTableCellModal>
                                  <StyledTableCellModal
                                    align={
                                      row.channel === null ? "center" : "left"
                                    }
                                  >
                                    {row.channel === null ? "-" : row.channel}
                                  </StyledTableCellModal>
                                  <StyledTableCellModal>
                                    <MuiPickersUtilsProvider
                                      id="MuiPickerDataTable"
                                      utils={DateFnsUtils}
                                      style={{ justifyContent: "center" }}
                                    >
                                      <DatePicker
                                        id={"DatePickerDataTable"}
                                        // style={{"& .react-date-picker__wrapper":{paddingRight: '10px',}}}
                                        className="loader__table-modal__datePicker"
                                        autoOk
                                        variant="inline"
                                        // inputVariant="outlined"
                                        placeholder="Sin Fecha"
                                        // disableFuture // desactiva dias futuros
                                        // disablePast // desactiva dias pasados
                                        disableToolbar
                                        format="dd/MM/yyyy"
                                        // minDate={
                                        //  new Date().setDate(new Date().getDate() - 1)
                                        // }
                                        maxDate={row.exp_date}
                                        value={row.start_date}
                                        onChange={(e) =>
                                          this.handleChangeDateModal(
                                            "start",
                                            row,
                                            index,
                                            e,
                                            this.state.rowsForModal,
                                            this.state.idRowSkuForModal
                                          )
                                        }
                                        style={{
                                          "& .react-date-picker__wrapper": {
                                            paddingRight: "10px",
                                            fontSize: "14px !important",
                                          },
                                        }}
                                      />
                                    </MuiPickersUtilsProvider>
                                    <EditIcon></EditIcon>
                                  </StyledTableCellModal>
                                  <StyledTableCellModal>
                                    <MuiPickersUtilsProvider
                                      id="MuiPickerDataTable"
                                      utils={DateFnsUtils}
                                      style={{ justifyContent: "center" }}
                                    >
                                      <DatePicker
                                        id={"DatePickerDataTableEnd"}
                                        // style={{"& .react-date-picker__wrapper":{paddingRight: '10px',}}}
                                        className="loader__table-modal__datePicker"
                                        autoOk
                                        variant="inline"
                                        // inputVariant="outlined"
                                        placeholder="Sin Fecha"
                                        // disableFuture // desactiva dias futuros
                                        //disablePast // desactiva dias pasados
                                        disableToolbar
                                        format="dd/MM/yyyy"
                                        // minDate={
                                        //  new Date().setDate(new Date().getDate() - 1)
                                        // }
                                        minDate={row.start_date}
                                        value={row.exp_date}
                                        onChange={(e) =>
                                          this.handleChangeDateModal(
                                            "end",
                                            row,
                                            index,
                                            e,
                                            this.state.rowsForModal,
                                            this.state.idRowSkuForModal
                                          )
                                        }
                                        style={{
                                          "& .react-date-picker__wrapper": {
                                            paddingRight: "10px",
                                            fontSize: "14px !important",
                                          },
                                        }}
                                      />
                                    </MuiPickersUtilsProvider>
                                    <EditIcon></EditIcon>
                                  </StyledTableCellModal>
                                </StyledTableRow>
                              ))
                          ) : totalRowsModal.accounts ? (
                            totalRowsModal.accounts.length > 0 ? (
                              totalRowsModal.accounts
                                .slice(
                                  this.state.page * this.state.rowsPerPage,
                                  this.state.page * this.state.rowsPerPage +
                                    this.state.rowsPerPage
                                )
                                .map((row, index) => (
                                  <StyledTableRow>
                                    <StyledTableCellModal
                                      align={
                                        row.client_id === null
                                          ? "center"
                                          : "left"
                                      }
                                    >
                                      {row.client_id === null
                                        ? "-"
                                        : row.client_id}
                                    </StyledTableCellModal>
                                    <StyledTableCellModal
                                      align={
                                        row.client_name === null
                                          ? "center"
                                          : "left"
                                      }
                                    >
                                      {row.client_name === null
                                        ? "-"
                                        : row.client_name}
                                    </StyledTableCellModal>
                                    <StyledTableCellModal
                                      align={
                                        row.gerencia === null
                                          ? "center"
                                          : "left"
                                      }
                                    >
                                      {row.gerencia === null
                                        ? "-"
                                        : row.gerencia}
                                    </StyledTableCellModal>
                                    <StyledTableCellModal
                                      align={
                                        row.uen === null ? "center" : "left"
                                      }
                                    >
                                      {row.uen === null ? "-" : row.uen}
                                    </StyledTableCellModal>
                                    <StyledTableCellModal
                                      align={
                                        row.channel === null ? "center" : "left"
                                      }
                                    >
                                      {row.channel === null ? "-" : row.channel}
                                    </StyledTableCellModal>
                                    <StyledTableCellModal
                                      align={
                                        row.start_date === null
                                          ? "center"
                                          : "left"
                                      }
                                    >
                                      {row.start_date === null
                                        ? "-"
                                        : row.start_date}
                                    </StyledTableCellModal>
                                    <StyledTableCellModal
                                      align={
                                        row.end_date === null
                                          ? "center"
                                          : "left"
                                      }
                                    >
                                      {row.end_datev === null
                                        ? "-"
                                        : row.end_date}
                                    </StyledTableCellModal>
                                  </StyledTableRow>
                                ))
                            ) : (
                              <StyledTableRow>
                                <StyledTableCellModal
                                  colSpan={7}
                                  align="center"
                                >
                                  No hay clientes impactados
                                </StyledTableCellModal>
                              </StyledTableRow>
                            )
                          ) : (
                            ""
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  ) : (
                    <></>
                  )}
                </div>
                <div
                  style={{ marginTop: "70px" }}
                  className="loader__actions__modal"
                >
                  <div
                    style={{ marginLeft: "30%" }}
                    className="loader__pagerModal"
                  >
                    <Paginador
                      pagesModal={pagesModal}
                      pagesModalState={this.state.pagesModal}
                      previousPageModal={this.previousPageModal}
                      selectPageModal={this.selectPageModal}
                      nextPageModal={this.nextPageModal}
                    />
                    {/* <DetailExclusions /> */}
                  </div>
                  <DropdownButton
                    className="loader__dropdown yellowModall"
                    onClick={(e) =>
                      totalRowsModal.affectedAccounts > 0
                        ? this.handleDownload(
                            "exclutionsForProduct",
                            this.state.idRowSkuForModal,
                            totalRowsModal.affectedAccounts,
                            pageCountForModal
                          )
                        : (e) => {}
                    }
                    title={this.state.labelDropdown}
                    disabled={
                      totalRowsModal.affectedAccounts === undefined ||
                      totalRowsModal.affectedAccounts === 0
                    }
                  ></DropdownButton>
                </div>
              </DialogContent>
            )}
          </span>
        </Dialog>

        <DialogHoneyLoad
          opened={this.state.openModalDounload}
          showIcon={true}
          iconType={"folder-loading"}
          messageDataParst={this.state.messageDounloadModal}
          isException={this.state.checked}
          // buttonCancel={true}
          buttonAccept={false}
          buttonDownload={true}
          dataParts={this.state.parstToDownload}
          closeModalGeneral={this.closeModalGeneral}
          // onClickCancel={updateModalState}
          // onClickAccept={e => onClickUpdate(activeElement)}
          showLoading={(e) => {
            this.dounloadSecment();
            this.setState({
              modalGeneral: true,
              messageGeneral: "Descargando archivo",
            });
          }}
          handleClose={(e) => this.dounloadSecment()}
          countriesCode={this.props.countriesCode}
          bacthId={this.state.idRowSkuForModal}
        />
      </div>
    );
  }
}
